import $ from 'jquery';

export default class ProductTypeSelect {
  static init() {
    const $productTypeSelect = $('.js__product-type-toggle');
    const productTypeSelectValue = $productTypeSelect.find('select').val();
    const $productDeviceTypeSelect = $('.js__device-type-field');
    const productDeviceTypeValue = $productDeviceTypeSelect.find('select').val();

    if (!$productTypeSelect.length) {
      const productTypeValue = $('.js__product-type-value').data('value');
      this.productTypeToggle(productTypeValue, productDeviceTypeValue);
      return;
    }

    this.productTypeToggle(productTypeSelectValue, productDeviceTypeValue);
    $productTypeSelect.on('change', 'select', e => {
      const productDeviceTypeValue = $productDeviceTypeSelect.find('select').val();
      this.productTypeToggle($(e.currentTarget).val(), productDeviceTypeValue);
    });
    $productDeviceTypeSelect.on('change', 'select', e => {
      const productTypeSelectValue = $productTypeSelect.find('select').val();
      this.productTypeToggle(productTypeSelectValue, $(e.currentTarget).val());
    });

    $('.js__remove-bundle-product').on('click', e => {
      e.preventDefault();
      this.removeBundleItemFromList(e);
    });

    this.bindBundleProducts($('.js__bundle-products'));
    $('.js__add-bundle-product').on('click', e => this.addFormToCollection(e));
  }

  static productTypeToggle(value, deviceType) {
    const isRegular = value === 'regular';
    const isStarterKit = value === 'starter_kit';
    const isDevice = deviceType !== 'null';

    $('.js__product-bundle-segment').toggleClass('hidden', isRegular || isStarterKit);
    if ((isRegular || isStarterKit) && $('div[id^="sylius_product_bundleProducts_"]').length > 0) {
      const $bundleProducts = $('.js__bundle-products');
      $bundleProducts.children().remove();
      $bundleProducts.attr('data-index', 0);
    }

    const $regularProduct = $('.js__product-regular');
    const $notStarterKitProduct = $('.js__product-not-starter-kit');
    const $RegularNotOtherDeviceProduct = $('.js__product-regular-not-other-device-segment');
    $('.js__product-bundle-info-label').toggleClass('hidden', isRegular || isStarterKit);
    $('.js__product-bundle')
      .closest('.field')
      .toggleClass('hidden', isRegular || isStarterKit);
    $('.js__product-bundle_enabled').attr('disabled', isRegular || isStarterKit ? 'disabled' : null);
    $('.js__product-regular-segment').toggleClass('hidden', !isRegular && !isStarterKit);
    $regularProduct.closest('.field').toggleClass('hidden', !isRegular);
    $regularProduct.closest('.js__hideable-block').toggleClass('hidden', !isRegular);
    $regularProduct.closest('.js__additional-product-variant-codes').toggleClass('hidden', !isRegular);
    $('.js__product-stock-count-field').closest('.field').toggleClass('hidden', !isRegular);
    $('.js__product-tracked-field').closest('.field').toggleClass('hidden', !isRegular);
    $notStarterKitProduct.toggleClass('hidden', isStarterKit);
    $notStarterKitProduct.closest('.field').toggleClass('hidden', isStarterKit);
    $RegularNotOtherDeviceProduct.toggleClass('hidden', (!isRegular && !isStarterKit) || (isRegular && !isDevice));
  }

  static addBundleProductFormDelete(bundleList) {
    $('<button/>', {
      class: 'ui red labeled icon button mt-3 js__remove-bundle-product',
      text: 'Remove',
    })
      .append('<i class="minus alternate icon"></i>')
      .appendTo(bundleList)
      .on('click', e => {
        this.removeBundleItemFromList(e);
      });
  }

  static removeBundleItemFromList(e) {
    $(e.target).parent().remove();
    this.updateFormFieldIndexes();
  }

  static updateFormFieldIndexes() {
    const $collectionHolder = $('.js__bundle-products');
    const currentIndex = $collectionHolder.attr('data-index');

    $collectionHolder.attr('data-index', Number.parseInt(currentIndex, 10) - 1);
    $collectionHolder.children().each((index, element) => {
      const $element = $(element);
      const $newPrototype = $($collectionHolder.data('prototype').replace(/__name__/g, index));
      $element.children().first().children().first().attr('id', $newPrototype.attr('id'));

      $element
        .children()
        .first()
        .children()
        .children()
        .each((fieldIndex, fieldElement) => {
          const $fieldWrapper = $(fieldElement);
          $fieldWrapper.find('label').attr('for', $($newPrototype.find('label')[Number(fieldIndex)]).attr('for'));
          $fieldWrapper
            .find('input:not(.search)')
            .attr('name', $($newPrototype.find('input')[Number(fieldIndex)]).attr('name'));
          $fieldWrapper
            .find('input:not(.search)')
            .attr('id', $($newPrototype.find('input')[Number(fieldIndex)]).attr('id'));
        });
    });
  }

  static addFormToCollection(e) {
    const $collectionHolder = $(`.${e.currentTarget.dataset.collectionHolderClass}`);
    const currentIndex = $collectionHolder.attr('data-index');
    const item = $('<div></div>');
    item.html($collectionHolder.data('prototype').replace(/__name__/g, currentIndex));

    $collectionHolder.append(item);
    this.addBundleProductFormDelete(item);
    $('<div class="ui hidden divider"></div>').appendTo(item);

    this.bindNewBundleProduct(currentIndex, $collectionHolder);
    $collectionHolder.attr('data-index', Number.parseInt(currentIndex, 10) + 1);
  }

  static rebuildVariantInput(e, index, $collectionHolder, $variantInput) {
    $variantInput.parent().remove();

    const variantInputItem = $('<div class="field"></div>');
    variantInputItem.attr('class', 'field');
    const variantTemplate = $collectionHolder.data('prototype').split('<div class="field">')[2];
    variantInputItem.html(variantTemplate.replace(/__name__/g, index));

    $(`#sylius_product_bundleProducts_${index}`).find('.js__bundle-product-select').parent().after(variantInputItem);
    const $newVariantInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-variant-select`);
    $newVariantInput.attr('data-url', `/door/ajax/bundle/product-variant/search/by-id?id=${e.currentTarget.value}`);
    $newVariantInput.autoComplete();
  }

  static bindBundleProducts($collectionHolder) {
    const $productInput = $(`div[id^="sylius_product_bundleProducts_"] .js__bundle-product-select`);

    $productInput.each((index, element) => {
      const selectedProduct = $(element).find('input').val();

      if (selectedProduct) {
        const $variantInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-variant-select`);

        $variantInput.attr('data-url', `/door/ajax/bundle/product-variant/search/by-id?id=${selectedProduct}`);
      }
    });

    $productInput.on('change', 'input', e => {
      const index = e.target.id.split('_')[3];
      const $variantInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-variant-select`);

      this.rebuildVariantInput(e, index, $collectionHolder, $variantInput);
    });
  }

  static bindNewBundleProduct(index, $collectionHolder) {
    const $productInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-select`);
    let $variantInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-variant-select`);
    $productInput.autoComplete();
    $variantInput.autoComplete();
    $productInput.on('change', 'input', e => {
      $variantInput = $(`#sylius_product_bundleProducts_${index} .js__bundle-product-variant-select`);
      this.rebuildVariantInput(e, index, $collectionHolder, $variantInput);
    });
  }
}
